// extracted by mini-css-extract-plugin
export default {"Bold":"advancedKyc_Bold__ZbMOM","Bold2":"advancedKyc_Bold2__tdEeN","Bold1":"advancedKyc_Bold1__p+Y+y"};